export function searchScore(item: string, searchLower: string): number {
  const lower = item.toLowerCase();
  if (lower === searchLower) return 3;
  if (lower.startsWith(searchLower)) return 2;
  if (lower.split(/[\s-]+/).some(w => w.startsWith(searchLower))) return 1;
  return 0;
}
